import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useApi, useDirectory } from "@/hooks/useApi";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, FilterBar, DataTable, StatusBadge, ErrorBox } from "@/components/common/ui-bits";
import { FormDialog } from "@/components/common/FormDialog";
import { clientFields } from "@/lib/schemas";
import { fmtDate, optionList, CLIENT_STATUSES, todayISO } from "@/lib/format";

export default function Clients() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin";
  const [q, setQ] = useState("");
  const [f, setF] = useState({});
  const { data, loading, error, reload } = useApi("/clients", { q, ...f });
  const { options: staff } = useDirectory();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <PageHeader title="Clientes" subtitle={isAdmin ? "Todos los clientes. Un cliente no se elimina: se desactiva o archiva." : "Clientes asignados a usted."}
        actions={isAdmin && <Button onClick={() => setOpen(true)} data-testid="new-client-button"><Plus className="mr-2 h-4 w-4" />Nuevo cliente</Button>} />
      <FilterBar search={q} onSearch={setQ} values={f} onChange={setF} testid="clients-filters" filters={[{ key: "status", label: "Estado", options: optionList(CLIENT_STATUSES) }]} />
      <ErrorBox text={error} />
      <DataTable testid="clients-table" quickView={(r) => r.trade_name || r.legal_name} loading={loading} rows={data} onRowClick={(r) => navigate(`/clientes/${r.id}`)} empty="No hay clientes."
        columns={[
          { key: "legal_name", label: "Cliente", render: (r) => <span className="font-medium text-slate-900">{r.trade_name || r.legal_name}<span className="block text-xs font-normal text-slate-500">{r.legal_name}</span></span> },
          { key: "contact_name", label: "Contacto" },
          { key: "email", label: "Correo" },
          { key: "phone", label: "Teléfono" },
          { key: "start_date", label: "Inicio", render: (r) => fmtDate(r.start_date) },
          { key: "status", label: "Estado", render: (r) => <StatusBadge status={r.status} /> },
        ]} />
      <FormDialog open={open} onOpenChange={setOpen} title="Nuevo cliente" testid="client-form" fields={clientFields(staff, isAdmin)}
        initial={{ status: "Activo", start_date: todayISO(), country: "Estados Unidos" }}
        onSubmit={async (v) => { const r = await api.post("/clients", v); toast.success("Cliente creado"); reload(); navigate(`/clientes/${r.data.id}`); }} />
    </div>
  );
}
